import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe za pretvaranje udaljenosti iz metara u metre ili kilometre s odgovarajućom oznakom.
 */
@Pipe({
  name: 'distanceConverter'
})
export class DistanceConverterPipe implements PipeTransform {

  /**
   * Pretvara udaljenost u metrima u formatirani tekst (m ili km).
   * @param value Udaljenost u metrima.
   * @returns Formatirani tekst udaljenosti.
   */
  transform(value: unknown, ...args: unknown[]): unknown {
    if (typeof value === 'number') {
      if (value < 1000) {
        return Math.round(value) + ' m';
      } else {
        return (value / 1000).toFixed(2) + ' km';
      }
    }
    return value;
  }

}
